import React from 'react';

export default function Home() {
    return (
        <main className="container mx-auto px-4 py-8 space-y-16">
            {/* Intro Section */}
            <section className="text-center max-w-3xl mx-auto">
                {/* Ensure avatar.png is in your public directory */}
                <img src='/avatar.png' alt="Kritik Agarwal" className="rounded-full w-40 h-40 md:w-48 md:h-48 mx-auto mb-6 shadow-xl object-cover" />
                <h2 className="text-3xl md:text-5xl font-extrabold mb-4 text-gray-900 leading-tight">
                    Hello, I'm <span className="text-blue-700">Kritik Agarwal</span>!
                </h2>
                <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                    An M.Tech graduate in Computer Science & Engineering from IIT Hyderabad,
                    I'm driven by a passion for cutting-edge technology.
                    I have successfully researched on CTGAN and transformer-based models for generating synthetic Electronic Health Records,
                    and I maintain a keen interest in the dynamic fields of Python and cybersecurity.
                </p>
            </section>

            {/* Quick Highlights */}
            <section className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="bg-white p-7 rounded-2xl shadow-lg border border-gray-100 transform hover:scale-105 transition-all duration-300">
                    <h3 className="text-xl font-bold mb-3 text-blue-700 flex items-center justify-center">
                        <span className="text-2xl mr-2">🔬</span> Research & AI
                    </h3>
                    <p className="text-gray-700">
                        My Master's thesis involved pioneering research on CTGAN and transformer-based models for synthetic Electronic Health Records (EHRs) generation using the MIMIC-IV dataset, with a strong focus on privacy and data utility.
                    </p>
                    <br />
                    <a href="https://raiith.krc.iith.ac.in/handle/123456789/63279" className="text-blue-700 hover:underline mt-2 inline-block font-medium">
                        View Thesis Publication <span aria-hidden="true">&rarr;</span>
                    </a>
                </div>
                <div className="bg-white p-7 rounded-2xl shadow-lg border border-gray-100 transform hover:scale-105 transition-all duration-300">
                    <h3 className="text-xl font-bold mb-3 text-blue-700 flex items-center justify-center">
                        <span className="text-2xl mr-2">🐍</span> Python & Cybersecurity
                    </h3>
                    <p className="text-gray-700">
                        Deeply passionate about Python development, network security, and protecting digital systems. Experienced in CTF challenges and exploring evolving threats and vulnerabilities.
                    </p>
                </div>
                <div className="bg-white p-7 rounded-2xl shadow-lg border border-gray-100 transform hover:scale-105 transition-all duration-300">
                    <h3 className="text-xl font-bold mb-3 text-blue-700 flex items-center justify-center">
                        <span className="text-2xl mr-2">✍️</span> Technical Insights
                    </h3>
                    <p className="text-gray-700">
                        I regularly share my experiences, learnings, and insights on computer science and engineering topics through detailed blog posts.
                        <br />
                        <a href="/blog" className="text-blue-700 hover:underline mt-2 inline-block font-medium">
                            Read My Latest Posts <span aria-hidden="true">&rarr;</span>
                        </a>
                    </p>
                </div>
            </section>

            {/* Call to Action */}
            <section className="text-center bg-gray-50 rounded-2xl shadow-inner px-6 py-10">
                <div className="flex items-center justify-center mb-4">
                    <span className="text-blue-800 text-3xl mr-2">✨</span>
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-900">Discover More About My Work</h3>
                </div>
                <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
                    Dive deeper into my academic journey, projects, and achievements. Feel free to explore my full curriculum vitae or reach out directly.
                </p>
                <div className="flex justify-center gap-6 flex-wrap">
                    <a
                        href="/cv"
                        className="bg-blue-700 text-white px-7 py-3 rounded-full hover:bg-blue-800 transition-all duration-300 font-semibold shadow-md"
                    >
                        View Full CV
                    </a>
                    <a
                        href="/contact"
                        className="bg-white border-2 border-blue-700 text-blue-700 px-7 py-3 rounded-full hover:bg-blue-50 transition-all duration-300 font-semibold shadow-md"
                    >
                        Get in Touch
                    </a>
                </div>
            </section>
        </main>
    );
}